import { render, staticRenderFns } from "./Team1.vue?vue&type=template&id=4dfb4fc5"
import script from "./Team1.vue?vue&type=script&lang=js"
export * from "./Team1.vue?vue&type=script&lang=js"
import style0 from "./Team1.vue?vue&type=style&index=0&id=4dfb4fc5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports